var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83301 3.3335V7.50016H4.31761M17.1148 9.16683C16.7047 5.87824 13.8994 3.3335 10.4997 3.3335C7.70186 3.3335 5.30658 5.05697 4.31761 7.50016M4.31761 7.50016H7.99967M17.1663 16.6668V12.5002H16.6817M16.6817 12.5002C15.6928 14.9434 13.2975 16.6668 10.4997 16.6668C7.09999 16.6668 4.29467 14.1221 3.88459 10.8335M16.6817 12.5002H12.9997",
    stroke: "#0052CC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.fc3f7c3f6598e8136782441e9e80d54d.svg";
export { ForwardRef as ReactComponent };